import {
  IContractAgreementMutation,
  IContractDistributionMutation,
  IContractDistributionShareMutation,
  IContractSectionMutation,
} from 'services/contract/types';
import { AGREEMENT_TYPE } from 'services/templates/agreement-template/types';
import {
  IContractTemplateTreeItemForm,
  IDistributionType,
  TEMPLATE_TYPE,
} from 'services/templates/types';

interface ISeparateContractTreeItems {
  subsections: IContractSectionMutation[];
  agreements: IContractAgreementMutation[];
  digitalDistribution: IContractDistributionMutation | null;
  physicalDistribution: IContractDistributionMutation | null;
  merchDistribution: IContractDistributionMutation | null;
  channelDistribution: IContractDistributionMutation | null;
}

export const getDistributionWithShares = (
  items: IContractTemplateTreeItemForm[],
  templateType: IDistributionType
): IContractDistributionMutation | null => {
  const itemsWithPosition = items.map((items, index) => ({
    ...items,
    position: index,
  }));

  const distributionItem = itemsWithPosition.find(
    item => item.type === templateType
  );

  let defaultShare = 0;

  const distributionShares =
    distributionItem?.children.reduce<IContractDistributionShareMutation[]>(
      (
        acc: IContractDistributionShareMutation[],
        item: IContractTemplateTreeItemForm
      ) => {
        if (
          item.type === TEMPLATE_TYPE.agreement &&
          item.content.distributionTemplateShares
        ) {
          if (
            item.content.type === AGREEMENT_TYPE.defaultShare &&
            item.content.distributionTemplateShares
          ) {
            defaultShare = item.content.distributionTemplateShares.percent ?? 0;
          }
          if (
            item.content.type === AGREEMENT_TYPE.shares &&
            !!item.content.distributionTemplateShares
          ) {
            const { id: salesChannelId, percent } =
              item.content.distributionTemplateShares;

            acc.push({
              salesChannelId,
              percentage: percent ?? 0,
            });
          }
        }
        return acc;
      },
      []
    ) ?? [];

  if (!!distributionItem && distributionItem.type === templateType) {
    return {
      defaultPercentage: defaultShare,
      title: distributionItem.content,
      position: distributionItem.position,
      shares: distributionShares,
    };
  }

  return null;
};

export const separateContractTreeItems = (
  items: IContractTemplateTreeItemForm[]
): ISeparateContractTreeItems => {
  const itemsWithPosition = items.map((items, index) => ({
    ...items,
    position: index,
  }));

  const agreements: IContractAgreementMutation[] = [];
  const subsections: IContractSectionMutation[] = [];
  for (const item of itemsWithPosition) {
    if (item.type === TEMPLATE_TYPE.agreement) {
      agreements.push({
        textAgreementRequest: {
          position: item.position,
          title: item.content.textAgreementTemplate?.title ?? '',
          defaultValue: item.content.textAgreementTemplate?.defaultValue ?? '',
        },
      });
    }
    if (item.type === TEMPLATE_TYPE.section) {
      const subItems = separateContractTreeItems(item.children);

      subsections.push({
        subsections: subItems.subsections,
        agreements: subItems.agreements,
        title: item.content,
        position: item.position,
      });
    }
  }
  return {
    subsections,
    agreements,
    digitalDistribution: getDistributionWithShares(
      items,
      TEMPLATE_TYPE.digitalDistribution
    ),
    physicalDistribution: getDistributionWithShares(
      items,
      TEMPLATE_TYPE.physicalDistribution
    ),
    merchDistribution: getDistributionWithShares(
      items,
      TEMPLATE_TYPE.merchDistribution
    ),
    channelDistribution: getDistributionWithShares(
      items,
      TEMPLATE_TYPE.channelDistribution
    ),
  };
};
